import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ResponsableTipoSelect from "./ResponsableTipoSelect.js"

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {Row, Col, Label, Input, InputGroup,FormFeedback} from 'reactstrap';

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    render() {
        return (
            <ParadigmaModal 
                postUrl={api.clientes.responsables.create} 
                successMessage={"El Contacto ha sido creado con éxito."} 
                title={"Nuevo Contacto"} 
                buttonIcon={"fa fa-plus fa-lg"} 
                onSubmit={(callback) => this.props.onSubmit(callback)} 
                buttonTitle={"Nuevo Contacto"}
                saveButton={true} 
                buttonClass={this.props.buttonClass}
                closeButton={true}>
                <Row>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Empresa</Label>
                        <ParadigmaAsyncSeeker fieldName={"empresa_id"} url={api.clientes.empresas.select}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-8">
                        <Label>Tipo</Label>
                        <ParadigmaAsyncSeeker fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Email</Label>
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Create.js